import React from 'react';

import { Container } from './styles'

function Material() {
  return (
    <Container>
      <section>
        <br/>
        <h1>MATERIAL PALESTRAS</h1>
        <br/>
        <p>Agradecemos por participar de nosso evento! Caso queira ter algum dos materiais das palestras, basta clicar nos butões abaixo
          para acessá-los. Em caso de dúvidas, basta entrar em contato pelo (62) 99609-0413 ou enviar para contato@expoprev.com.br.
        </p>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/3_9h10_Impactos-da-Nova-Portaria-Goiânia-2022.pptx' target='_blank' rel="noreferrer">
          <button>A Consolidação e Atualização dos Parâmetros Gerais dos RPPS - SPREV</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/4a-EXPOPREV-e-2a-AGOPREV.pdf' target='_blank' rel="noreferrer">
          <button>A Reforma da Previdência e seus Impactos nos Municípios e Estados</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/EXPOPREV-2022-Aposentadorias-especiais.pptx' target='_blank' rel="noreferrer">
          <button>Aposentadorias Especiais</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/APRESENTAÇÃO-CADPREV-GOIÂNIA.pptx' target='_blank' rel="noreferrer">
          <button>As Principais Mudanças no Sistema CADPREV</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/Goiania-BGC-correto.pdf' target='_blank' rel="noreferrer">
          <button>BGC Liquidez</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/ApresentaÃ§Ão-AGOPREV.pptx' target='_blank' rel="noreferrer">
          <button>Cenário Econômico - BB DTVM</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/ItaúExpoprev2022.pptx' target='_blank' rel="noreferrer">
          <button>Cenário Macroeconômico - Itaú</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/1_9h_CERTIFICAÇÃO-PROFISSIONAL-Goiânia-06-JUL-2022.pptx' target='_blank' rel="noreferrer">
          <button>Certificação Profissional dos Dirigentes e Conselheiros RPPS</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/Palestra-Critérios-nos-cálculos-de-aposentadoria-e-verbas-permanentes-e-transitórias.pdf' target='_blank' rel="noreferrer">
          <button>Critérios nos Cálculos de Aposentadoria e Verbas Permanentes e Transitórias</button>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/AGOPREV-jul2022.pptx' target='_blank' rel="noreferrer">
          <button>Custeio das Despesas Administrativas do RPPS - AGOPREV</button>
        </a>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/2_11h_Consignados-e-Parcelamento-EC-113-Goiânia-2022.pptx' target='_blank' rel="noreferrer">
          <button>Empréstimos Consignados (Resolução CMN nº4.963/21)</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/eSocial-órgãos-públicos-Simplificado.pptx' target='_blank' rel="noreferrer">
          <button>eSocial para Órgãos Públicos</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/2.5.-agoprev-expoprev-2022.pptx' target='_blank' rel="noreferrer">
          <button>Nova Certificação RPPS - Milton Moreira</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/MAG_PIM202205.pdf' target='_blank' rel="noreferrer">
          <button>Produção Industrial Mensal - MAG</button>
        </a>
        <br/>
        <br/>
        <a href='http://jornadaeduc.com.br/wp-content/uploads/2022/07/Apresentação-Tulio.pdf' target='_blank' rel="noreferrer">
          <button>Alternativa de Fonte de Custeio - ARIMA</button>
        </a>
        <br/>
        <br/>
        <br/>
        <a href='https://drive.google.com/drive/folders/11XQl0ZzOaU2yxVax4_1qGH42kB1uPd12?usp=sharing' target='_blank' rel="noreferrer">
          <button id='a'>Baixar Todo Material</button>
        </a>
      </section>
      <br/>
      <br/>
    </Container>
  );
}

export default Material;